export const headers = {
  Accept: 'application/json',
  // 'Content-Type': 'application/json',
};

export const meterConversionRatio = 0.000621371;
export const selectedLocationMilesThreshold = 30.0;
export const cookieDomain = '.twomenbeta.com';
